// fetchWithAuth.js
import { isPublicAnonymousRoute } from "../utils/publicAuthPaths";

export async function fetchWithAuth(url, options = {}) {
  const isFormData =
    typeof FormData !== 'undefined' && options.body instanceof FormData;
  const incomingHeaders = { ...(options.headers || {}) };
  const hasExplicitContentType = Object.keys(incomingHeaders).some(
    (key) => key.toLowerCase() === 'content-type'
  );

  const finalOptions = {
    ...options,
    credentials: 'include', // Send HTTP-only cookies
    headers: {
      ...incomingHeaders,
      ...(!isFormData && !hasExplicitContentType
        ? { 'Content-Type': 'application/json' }
        : {}),
    },
  };

  try {
    // ✅ Use native fetch, not fetchWithAuth
    const response = await fetch(url, finalOptions);

    if (response.status === 401) {
      const path =
        typeof window !== "undefined" ? window.location.pathname || "/" : "/";
      if (isPublicAnonymousRoute(path)) {
        return response;
      }
      console.warn("Session expired. Logging out...");
      window.location.href = "/";
      return;
    }

    // Optional: throw on other non-OK responses
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message = errorData.error || errorData.message || `Request failed with status ${response.status}`;
      const error = new Error(message);
      error.status = response.status;
      error.data = errorData;
      throw error;
    }


    return response; // unparsed

  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
}
